import { ResponsiveBar } from "@nivo/bar";

const DepartmentBarChart = ({ data }) => {
  return (
    <div className="bg-white p-2 md:p-6 rounded-xl border border-slate-200 shadow-sm">
      <h3 className="text-lg pl-2 md:pl-0 font-semibold mb-4">Department Occupancy (%)</h3>

      <div className="h-60 md:h-80">
        <ResponsiveBar
          data={data}
          keys={["occupancy"]}
          indexBy="name"
          enableLabel={true}
          labelTextColor="#ffffff"
          labelSkipWidth={12}
          labelSkipHeight={12}
          layout="horizontal" // matches Recharts vertical layout
          margin={{ top: 10, right: 20, bottom: 20, left: 80 }}
          padding={0.4}
          borderRadius={6}
          colors={["#1D4ED8"]}
          enableGridX={false}
          enableGridY={false}
          axisTop={null}
          axisRight={null}
          axisBottom={null} // hides number axis (like your hidden XAxis)
          axisLeft={{
            tickSize: 0,
            tickPadding: 10,
            tickRotation: 0,
            legend: "",
            legendOffset: 0,
            legendPosition: "middle",
          }}
          tooltip={({ value, indexValue }) => (
            <div className="bg-white px-3 py-2 rounded-lg shadow-md border text-sm">
              <strong>{indexValue}</strong>
              <div className="text-slate-600">{value}%</div>
            </div>
          )}
          theme={{
            axis: {
              ticks: {
                text: {
                  fill: "#475569",
                  fontSize: 12,
                },
              },
            },
          }}
          animate={true}
          motionConfig="gentle"
        />
      </div>
    </div>
  );
};

export default DepartmentBarChart;
